import { ModuleTypes, UserRoleEnum, UserAccountStatusEnum } from 'components/Modals/Filter/types';
import { config } from 'config/config';
import { RequestMethod } from "utils/useApiClient";

const filterModules = [
    {
        name: 'eventSubjectType',
        label: 'general.event_subject_type',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.enums.eventSubjectTypes,
        isEnum: true,
    },
    {
        name: 'students',
        label: 'general.student',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.users,
        filters: {
            role: [UserRoleEnum.Student],
            limit: 5,
            select: ['displayName', 'id', 'user_id'],
        },
        valueKey: 'id',
        method: 'POST' as RequestMethod,
        labelKey: 'displayName',
        searchKey: 'qu',
    },
    {
        name: 'eventInitiatorId',
        label: 'general.event_initiator',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.users,
        filters: {
            role: [UserRoleEnum.Admin, UserRoleEnum.CustomerAdmin],
            limit: 5,
            select: ['displayName', 'id', 'user_id'],
        },
        valueKey: 'id',
        method: 'POST' as RequestMethod,
        labelKey: 'displayName',
        searchKey: 'qu',
    },
    {
        name: 'createdAt',
        label: 'general.created_at',
        type: ModuleTypes.dateRange,
    },
];

export { filterModules };
